<template>
  <div class="">
    <div class="swiper-container">
      <div class="mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in data" :key="index">
            <div class="case-container">
              <CaseCard :data="item" />
            </div>
          </div>
        </div>
      </div>
      <!--  <van-swipe
        class="screenshot-swipe"
        :autoplay="200000"
        :loop="false"
        :show-indicators="false"
        @change="bindChange"
      >
        <van-swipe-item
          class="screenshot-item"
          v-for="(item, index) in data"
          :key="index"
        >
          <div class="case-container">
            <CaseCard :data="item" />
          </div>
        </van-swipe-item>
      </van-swipe> -->
    </div>
    <div class="swiper-indicator">
      <span
        class="swiper-indicator-item"
        :class="{
          'swiper-indicator-item-active': curSwipe == index
        }"
        v-for="(item, index) in data"
        :key="index"
      ></span>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper-bundle.min.css'
import CaseCard from './case-card.vue'
export default {
  components: { CaseCard },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      curSwipe: 0
    }
  },
  created() {},
  mounted() {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      let self = this
      this.$nextTick(() => {
        this.swiper = new Swiper('.mySwiper', {
          slidesPerView: 'auto', //每页显示数量，auto为自动填充，3为每页显示3块
          centeredSlides: false, //轮播图自动居中
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
          spaceBetween: 10, //轮播图左右之间的间距，配合css样式中的width实现效果
          initialSlide: 0, //轮播图初始下标位置
          autoHeight: false,
          //方法事件
          on: {
            //回调函数，swiper从当前slide开始过渡到另一个slide时执行
            slideChange: function () {
              self.curSwipe = this.activeIndex
            }
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.swiper-container {
  overflow: hidden;
  transform: translate3d(0, 0, 0);
}
.screenshot-swipe {
  width: 301px;
  margin: 0 auto 0 16px;
  overflow: visible;
  .screenshot-item {
    width: 100%;
    box-sizing: border-box;
    .case-container {
      padding-right: 10px;
    }
  }
}
.swiper-indicator {
  margin-top: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.swiper-indicator .swiper-indicator-item {
  width: 4px;
  height: 4px;
  background: rgba(0, 0, 0, 0.24);
  border-radius: 2px;
  margin-right: 3px;
}
.swiper-indicator .swiper-indicator-item-active {
  width: 16px;
  height: 4px;
  background: #6236ff;
  border-radius: 2px;
}
.swiper-wrapper {
  align-items: flex-end;
}
/* 每个轮播图占比大小，100%则整个屏幕铺满 */
.swiper-slide {
  width: 291px;
  height: auto;
}
</style>
